import { getProductImageUrl } from "../../../utils/productImageLoader";

const CategoryPeerImages = ({
  peers,
  categoryName,
  categorySlug,
  loading,
  loadFailed,
}) => {
  if (!categorySlug && !loading) return null;

  if (loading) {
    return (
      <section className="product-edit-img__section product-edit-img__peers">
        <h3 className="product-edit-img__section-title">
          תמונות מוצרים בקטגוריה
        </h3>
        <p className="product-edit-img__peers-status">טוען תמונות...</p>
      </section>
    );
  }

  if (!peers.length) {
    return (
      <section className="product-edit-img__section product-edit-img__peers">
        <h3 className="product-edit-img__section-title">
          תמונות מוצרים בקטגוריה
          {categoryName ? ` — ${categoryName}` : ""}
        </h3>
        <p className="product-edit-img__peers-status">
          {loadFailed
            ? "לא ניתן לטעון תמונות ממוצרים אחרים בקטגוריה."
            : "לא נמצאו תמונות ממוצרים אחרים בקטגוריה זו."}
        </p>
      </section>
    );
  }

  return (
    <section className="product-edit-img__section product-edit-img__peers">
      <h3 className="product-edit-img__section-title">
        תמונות מוצרים בקטגוריה
        {categoryName ? ` — ${categoryName}` : ""}
      </h3>

      <div className="product-edit-img__peer-grid">
        {peers.map((peer) => (
          <div key={peer.productId} className="product-edit-img__peer-card">
            <img
              src={getProductImageUrl(peer.media.path)}
              alt=""
              className="product-edit-img__peer-image"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryPeerImages;
